import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './button';

export default function Pagination({ page, totalPages, totalItems, pageSize, onPageChange, itemLabel }) {
    if (!totalItems) return null;

    const start = (page - 1) * pageSize + 1;
    const end = Math.min(page * pageSize, totalItems);

    const pages = () => {
        if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
        const delta = 1;
        const left = Math.max(2, page - delta);
        const right = Math.min(totalPages - 1, page + delta);
        const result = [1];
        if (left > 2) result.push('…');
        for (let i = left; i <= right; i++) result.push(i);
        if (right < totalPages - 1) result.push('…');
        result.push(totalPages);
        return result;
    };

    return (
        <div className="mt-6 flex flex-col items-center gap-3 sm:flex-row sm:justify-between">
            <p className="text-sm text-muted-foreground">
                Showing <span className="font-medium text-foreground">{start}–{end}</span> of{' '}
                <span className="font-medium text-foreground">{totalItems}</span>
                {itemLabel ? ` ${itemLabel}` : ''}
            </p>
            {totalPages > 1 && (
            <div className="flex items-center gap-1">
                <Button
                    variant="outline"
                    size="icon"
                    className="h-8 w-8"
                    disabled={page === 1}
                    onClick={() => onPageChange(page - 1)}
                    aria-label="Previous page"
                >
                    <ChevronLeft className="h-4 w-4" />
                </Button>
                {pages().map((p, i) =>
                    p === '…' ? (
                        <span key={`dots-${i}`} className="flex h-8 w-8 items-center justify-center text-sm text-muted-foreground">
                            …
                        </span>
                    ) : (
                        <Button
                            key={p}
                            variant={p === page ? 'default' : 'outline'}
                            size="icon"
                            className="h-8 w-8 text-sm"
                            onClick={() => onPageChange(p)}
                            aria-current={p === page ? 'page' : undefined}
                        >
                            {p}
                        </Button>
                    )
                )}
                <Button
                    variant="outline"
                    size="icon"
                    className="h-8 w-8"
                    disabled={page === totalPages}
                    onClick={() => onPageChange(page + 1)}
                    aria-label="Next page"
                >
                    <ChevronRight className="h-4 w-4" />
                </Button>
            </div>
            )}
        </div>
    );
}
